<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>推配置</span>
        </div>

        <span>基本配置</span>
        <el-divider />
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="开关">
            <el-select v-model.number="formData.gameCfg.status" placeholder="请选择">
              <el-option
                v-for="item in switchType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="安卓开关">
            <el-select v-model.number="formData.gameCfg.androidSet.status" placeholder="请选择">
              <el-option
                v-for="item in switchType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="安卓-最小开启版本">
            <el-input v-model="formData.gameCfg.androidSet.minVersion" style="width: 100px;" placeholder="最小开启版本" />
          </el-form-item>
          <el-form-item label="IOS开关">
            <el-select v-model.number="formData.gameCfg.iosSet.status" placeholder="请选择">
              <el-option
                v-for="item in switchType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="安卓-最小开启版本">
            <el-input v-model="formData.gameCfg.iosSet.minVersion" style="width: 100px;" placeholder="最小开启版本" />
          </el-form-item>

        </el-form>
        <span>免费次数</span>
        <el-divider />
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="免费次数">
            <el-input v-model.number="formData.gameCfg.freeLimit" style="width: 100px;" placeholder="免费次数" />
          </el-form-item>
          <el-form-item label="初始化桌面模式">
            <el-select v-model.number="formData.gameCfg.iosSet.status" placeholder="请选择">
              <el-option
                v-for="item in modeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="购买游戏(价格)">
            <el-input v-model.trim="formData.gameCfg.buyGameLimit.prize" style="width: 100px;" placeholder="购买游戏(价格)" />
          </el-form-item>
          <el-form-item label="购买游戏(次数)">
            <el-input v-model.number="formData.gameCfg.buyGameLimit.maxNum" style="width: 100px;" placeholder="购买游戏(次数)" />
          </el-form-item>
        </el-form>

        <span>道具价格</span>
        <el-divider />
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="价格(p1)">
            <el-input v-model.trim="formData.gameCfg.buyGameProp.p1.prize" style="width: 100px;" placeholder="价格(p1)" />
          </el-form-item>
          <el-form-item label="最大次数(p1)">
            <el-input v-model.trim="formData.gameCfg.buyGameProp.p1.maxNum" style="width: 100px;" placeholder="最大次数(p1)" />
          </el-form-item>
          <el-form-item label="价格(p2)">
            <el-input v-model.trim="formData.gameCfg.buyGameProp.p2.prize" style="width: 100px;" placeholder="价格(p1)" />
          </el-form-item>
          <el-form-item label="最大次数(p2)">
            <el-input v-model.trim="formData.gameCfg.buyGameProp.p2.maxNum" style="width: 100px;" placeholder="最大次数(p1)" />
          </el-form-item>
        </el-form>
        <span>常规用户</span>
        <el-divider />
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="开放等级">
            <el-input v-model.number="formData.gameCfg.commonCfg.openLevel" style="width: 100px;" placeholder="开放等级" />
          </el-form-item>
          <el-form-item label="体验次数">
            <el-input v-model.number="formData.gameCfg.commonCfg.freeExpLimit" style="width: 100px;" placeholder="体验次数" />
          </el-form-item>
          <el-form-item label="体验等级">
            <el-input v-model.number="formData.gameCfg.commonCfg.expLevel" style="width: 100px;" placeholder="体验等级" />
          </el-form-item>
          <el-form-item label="开放渠道体验">
            <el-select v-model.number="formData.gameCfg.commonCfg.openExp" placeholder="请选择">
              <el-option
                v-for="item in switchType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span>广告渠道用户</span>
        <el-divider />
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="开放等级">
            <el-input v-model.number="formData.gameCfg.specialCfg.openLevel" style="width: 100px;" placeholder="开放等级" />
          </el-form-item>
          <el-form-item label="体验次数">
            <el-input v-model.number="formData.gameCfg.specialCfg.freeExpLimit" style="width: 100px;" placeholder="体验次数" />
          </el-form-item>
          <el-form-item label="体验等级">
            <el-input v-model.number="formData.gameCfg.specialCfg.expLevel" style="width: 100px;" placeholder="体验等级" />
          </el-form-item>
          <el-form-item label="开放渠道体验">
            <el-select v-model.number="formData.gameCfg.specialCfg.openExp" placeholder="请选择">
              <el-option
                v-for="item in switchType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button v-permisaction="['config:coinDozer:add']" type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCoinDozerCfg, updateCoinDozerCfg } from '@/api/config/sys-cfg'
export default {
  name: 'CoinDozer',
  data() {
    return {
      switchType: [
        {
          'value': 1,
          'label': '开启'
        },
        {
          'value': 0,
          'label': '关闭'
        }
      ],
      modeType: [
        {
          'value': 1,
          'label': '默认模式'
        }
      ],
      formData: {
        'gameCfg': {
          'status': 0,
          'androidSet': {
            'status': 1,
            'minVersion': '1.7.0'
          },
          'iosSet': {
            'status': 1,
            'minVersion': '1.7.8'
          },
          'freeLimit': 1,
          'initTableModel': 1,
          'buyGameLimit': {
            'prize': 20,
            'maxNum': 10000
          },
          'buyGameProp': {
            'p1': {
              'prize': 20,
              'maxNum': 100
            },
            'p2': {
              'prize': 40,
              'maxNum': 100
            }
          },
          'commonCfg': {
            'openLevel': 100,
            'freeExpLimit': 0,
            'expLevel': 0,
            'openExp': 0
          },
          'specialCfg': {
            'openLevel': 100,
            'freeExpLimit': 1,
            'expLevel': 1,
            'openExp': 0
          }
        },
        'exchangeRateCfg': [
          {
            'level': 1,
            'er': 1
          },
          {
            'level': 2,
            'er': 2
          },
          {
            'level': 3,
            'er': 2
          },
          {
            'level': 4,
            'er': 4
          },
          {
            'level': 5,
            'er': 5
          },
          {
            'level': 6,
            'er': 10
          }
        ],
        'siteProbCfg': [
          {
            'id': 1,
            'weight': 12
          },
          {
            'id': 2,
            'weight': 12
          },
          {
            'id': 3,
            'weight': 10
          },
          {
            'id': 4,
            'weight': 9
          },
          {
            'id': 5,
            'weight': 15
          },
          {
            'id': 6,
            'weight': 6
          },
          {
            'id': 7,
            'weight': 15
          },
          {
            'id': 8,
            'weight': 6
          },
          {
            'id': 9,
            'weight': 4
          },
          {
            'id': 10,
            'weight': 6
          },
          {
            'id': 11,
            'weight': 2
          },
          {
            'id': 12,
            'weight': 1
          },
          {
            'id': 13,
            'weight': 2
          }
        ],
        'propDropRule': [
          {
            'stage': 100,
            'everyNum': 10,
            'dropNum': 1
          },
          {
            'stage': 500,
            'everyNum': 12,
            'dropNum': 1
          },
          {
            'stage': 1000,
            'everyNum': 15,
            'dropNum': 1
          },
          {
            'stage': 2000,
            'everyNum': 20,
            'dropNum': 1
          },
          {
            'stage': 10000,
            'everyNum': 25,
            'dropNum': 1
          },
          {
            'stage': 100000000,
            'everyNum': 30,
            'dropNum': 1
          }
        ],
        'propProbCfg': [
          {
            'id': 1,
            'weight': 400,
            'type': 14,
            'rtype': 2,
            'snum': 2,
            'enum': 5
          },
          {
            'id': 2,
            'weight': 200,
            'type': 14,
            'rtype': 2,
            'snum': 6,
            'enum': 10
          },
          {
            'id': 3,
            'weight': 50,
            'type': 14,
            'rtype': 2,
            'snum': 11,
            'enum': 20
          },
          {
            'id': 4,
            'weight': 10,
            'type': 14,
            'rtype': 2,
            'snum': 21,
            'enum': 50
          },
          {
            'id': 5,
            'weight': 50,
            'type': 15,
            'rtype': 1,
            'snum': 1,
            'enum': 1
          },
          {
            'id': 6,
            'weight': 10,
            'type': 15,
            'rtype': 1,
            'snum': 2,
            'enum': 2
          },
          {
            'id': 7,
            'weight': 1,
            'type': 15,
            'rtype': 2,
            'snum': 3,
            'enum': 5
          },
          {
            'id': 8,
            'weight': 0,
            'type': 15,
            'rtype': 2,
            'snum': 1,
            'enum': 1
          },
          {
            'id': 9,
            'weight': 120,
            'type': 1,
            'rtype': 1,
            'snum': 1,
            'enum': 1
          },
          {
            'id': 10,
            'weight': 50,
            'type': 2,
            'rtype': 1,
            'snum': 1,
            'enum': 1
          },
          {
            'id': 11,
            'weight': 10,
            'type': 3,
            'rtype': 1,
            'snum': 1,
            'enum': 1
          },
          {
            'id': 12,
            'weight': 120,
            'type': 8,
            'rtype': 1,
            'snum': 100,
            'enum': 100
          },
          {
            'id': 13,
            'weight': 50,
            'type': 8,
            'rtype': 1,
            'snum': 500,
            'enum': 500
          },
          {
            'id': 14,
            'weight': 10,
            'type': 8,
            'rtype': 1,
            'snum': 1000,
            'enum': 1000
          },
          {
            'id': 15,
            'weight': 5,
            'type': 8,
            'rtype': 1,
            'snum': 2500,
            'enum': 2500
          },
          {
            'id': 16,
            'weight': 2,
            'type': 8,
            'rtype': 1,
            'snum': 5000,
            'enum': 5000
          }
        ]
      }
    }
  },
  created() {
    this.getTables('android')
  },
  methods: {
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    onSubmit(name) {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateCoinDozerCfg({ name: 'config', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCoinDozerCfg().then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
